import React, { useRef, useMemo, useState } from "react";
import { Box, Button, Dialog, DialogContent } from "@mui/material";
import { Stack, Radio, RadioGroup, Typography } from "@mui/material";
import { FormControl, FormControlLabel } from "@mui/material";
import Barcode from "react-barcode";
import { useReactToPrint } from "react-to-print";
import { itemNewDesign } from "../../components/features/ItemNewDesign";

const BarcodesPrint = ({ onClose, onSuccess, items }) => {
  console.log(items);
  let existingCols = localStorage.getItem("barcodeCols") || "";
  console.log(existingCols);
  const printRef = useRef(null);
  const [type, setType] = useState("small");
  console.log("type:", type);

  const handlePrint = () => {
    print();
    onSuccess();
  };
  const print = useReactToPrint({
    content: () => printRef.current,
  });

  const handleType = (e) => {
    const { value } = e.target;
    setType(value);
  };

  const cols = useMemo(() => {
    if (existingCols) {
      let keys = [];
      let data = JSON.parse(existingCols);
      for (const key in data) {
        if (key != "name") {
          keys.push(key);
        }
      }
      return keys;
    } else {
      return [];
    }
  }, [existingCols]);
  const descFound = useMemo(() => {
    if (existingCols) {
      let data = JSON.parse(existingCols);
      if (data?.description) {
        return true;
      } else {
        return false;
      }
    } else {
      return null;
    }
  }, [existingCols]);

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent>
        <Stack direction="row" spacing="16px">
          <Button
            variant="contained"
            sx={{ textTransform: "none", background: "#999 !important" }}
            onClick={onClose}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{ textTransform: "none" }}
            onClick={handlePrint}
          >
            Print
          </Button>
          <FormControl>
            <RadioGroup row value={type} onChange={handleType}>
              <FormControlLabel
                disableRipple
                value="small"
                control={<Radio disableRipple />}
                label="Small Size"
              />
              <FormControlLabel
                disableRipple
                value="large"
                control={<Radio disableRipple />}
                label="Large Size"
              />
              <FormControlLabel
                disableRipple
                value="both"
                control={<Radio disableRipple />}
                label="Both"
              />
            </RadioGroup>
          </FormControl>
        </Stack>
        <Box
          ref={printRef}
          sx={{
            p: "16px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          {items.map((item, i) => (
            <Box key={i} sx={{ mr: 0.8 }}>
              {(type == "small" || type == "both") && (
                <Box>
                  <Barcode height={50} fontSize={15} value={item?.barCode} />
                  <Typography sx={{ textAlign: "center", fontWeight: 700 }}>
                    {item?.name}
                  </Typography>
                  {descFound && (
                    <Typography sx={{ textAlign: "center" }}>
                      {item?.description}
                    </Typography>
                  )}
                  {itemNewDesign() && (
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography sx={{ textAlign: "center" }}>
                        {item?.material}
                      </Typography>
                      <Typography sx={{ textAlign: "center" }}>
                        {item?.color}
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                    {cols.map((col, idx) => {
                      return item[col] && col != "description" ? (
                        <Box key={idx} sx={{ minWidth: "50%" }}>
                          <Typography>{item[col]}</Typography>
                        </Box>
                      ) : col == "companyName" ? (
                        <Box key={idx} sx={{ minWidth: "100%" }}>
                          <Typography sx={{ textAlign: "center" }}>
                            {localStorage.getItem("company")}
                          </Typography>
                        </Box>
                      ) : null;
                    })}
                  </Box>
                </Box>
              )}
              {(type == "large" || type == "both") && (
                <Box>
                  <Barcode height={80} fontSize={20} value={item?.barCode} />
                  <Typography
                    sx={{
                      fontSize: "20px",
                      textAlign: "center",
                      fontWeight: 700,
                    }}
                  >
                    {item?.name}
                  </Typography>
                  {descFound && (
                    <Typography sx={{ fontSize: "20px", textAlign: "center" }}>
                      {item?.description}
                    </Typography>
                  )}
                  {itemNewDesign() && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "20px", textAlign: "center" }}
                      >
                        {item?.material}
                      </Typography>
                      <Typography
                        sx={{ fontSize: "20px", textAlign: "center" }}
                      >
                        {item?.color}
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                    {cols.map((col, idx) => {
                      return item[col] && col != "description" ? (
                        <Box key={idx} sx={{ minWidth: "50%" }}>
                          <Typography sx={{ fontSize: "20px" }}>
                            {item[col]}
                          </Typography>
                        </Box>
                      ) : col == "companyName" ? (
                        <Box key={idx} sx={{ minWidth: "100%" }}>
                          <Typography
                            sx={{ fontSize: "20px", textAlign: "center" }}
                          >
                            {localStorage.getItem("company")}
                          </Typography>
                        </Box>
                      ) : null;
                    })}
                  </Box>
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BarcodesPrint;
